module.exports = __webpack_public_path__ + "static/banner_bg_3-1e906420b272950ace15742710b7fc93.png";